export default __webpack_public_path__ + "static/media/inn-product-page.5d4e0a8e.png";